import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import GuideLevelListStore from './GuideLevelListStore';
import LineItem from './LineItem.react';
import {GuideLevelModelV2} from 'resources/augmented/GuideLevel/GuideLevelModel.v2';
import {GuideModelV1} from 'resources/augmented/Guide/GuideModel.v1';
import SubtopicList from './SubtopicList.react';

export default class TopicList extends React.Component {
  static propTypes = {
    topics: ImmutablePropTypes.list.isRequired,
    theme: PropTypes.instanceOf(GuideLevelModelV2),
    guide: PropTypes.instanceOf(GuideModelV1),
    store: PropTypes.instanceOf(GuideLevelListStore)
  };

  render() {
    if (this.props.topics.isEmpty()) {
      return null;
    }

    return (
      <ul className='guide-table-list-group'>
        {this.props.topics.map((topic) => {
          const subtopics = this.props.guide.getSortedSubtopics(
            this.props.theme.getId(),
            topic.getId()
          );
          const hasChildren = !subtopics.isEmpty();
          const shouldShowChildren = this.props.store.isGuideExpanded(topic.getId());
          return [
            <LineItem
              key={topic.getId()}
              storeName={`topic-${topic.getId()}-name-overflow-store`}
              guideLevel={topic}
              indentLevel={2}
              isExpandable={hasChildren}
              isExpanded={shouldShowChildren}
              expandStoreName={this.props.store.getName()}
            />,
            hasChildren && shouldShowChildren ? (
              <SubtopicList key={`topic-${topic.getId()}-subtopics`} subtopics={subtopics} />
            ) : null
          ];
        })}
      </ul>
    );
  }
}
